import { render, staticRenderFns } from "./sales-direct-input-no-order.vue?vue&type=template&id=10a6a271&scoped=true&"
import script from "./sales-direct-input-no-order.vue?vue&type=script&lang=js&"
export * from "./sales-direct-input-no-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a6a271",
  null
  
)

export default component.exports